import React from 'react'
import { Button, Form } from 'semantic-ui-react'

import DistrictField from './DistrictField'
import CommunesField from './CommunesField'

export default class ZoneForm extends React.PureComponent {
  onChange = (field, value ) => {
    const { zone, onChange } = this.props

    let selectedCommunes = field === 'selectedCommunes' ? value : []

    if (field === 'selectedCommunes' && value.includes('select-all')) {
      selectedCommunes = zone.allCommunes.map(commune => commune.id)
    }

    onChange({
      district: zone.district,
      [field]: value,
      selectedCommunes,
    })
  }

  render() {
    const { districts, selectedDistricts, onRemove, zone, action } = this.props

    return (
      <div>
        <Form.Group widths='equal'>
          <DistrictField
            selectedDistrict={zone.district || ""}
            selectedDistricts={selectedDistricts}
            disabled={action === 'edit' && !selectedDistricts.includes(zone.district)}
            districts={districts}
            onChange={(data) => this.onChange('district', data.value)}
          />
          <div style={{ paddingTop: 25, marginRight: 10, marginLeft: 10 }}>
            <Button as='a' icon='trash' color="red" size="tiny" onClick={onRemove} />
          </div>
        </Form.Group>

        <Form.Group widths='equal'>
          <CommunesField
            selectedCommunes={zone.selectedCommunes || []}
            communes={zone.allCommunes|| []}
            onChange={(data) => this.onChange('selectedCommunes', data.map(d => d.value))}
          />
        </Form.Group>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/components/ZoneForm.js